import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { SWRProvider } from "./providers/SWRProvider";
import { ThemeProvider } from "./providers/ThemeProvider";
import "@/styles/index.css";

function installZoomGuard() {
	const preventZoom = (event: Event) => event.preventDefault();
	const preventCtrlWheelZoom = (event: WheelEvent) => {
		if (event.ctrlKey) event.preventDefault();
	};

	for (const eventName of ["gesturestart", "gesturechange", "gestureend"]) {
		document.addEventListener(eventName, preventZoom, { passive: false });
	}

	document.addEventListener("wheel", preventCtrlWheelZoom, { passive: false });
}

installZoomGuard();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<ThemeProvider>
			<SWRProvider>
				<BrowserRouter>
					<ErrorBoundary>
						<App />
					</ErrorBoundary>
				</BrowserRouter>
			</SWRProvider>
		</ThemeProvider>
	</React.StrictMode>,
);
